// src/components/BrowserCompatNotice.js
import React, { useState } from 'react';
import { getBrowserEnv, getOpenInChromeUrl } from '../lib/recaptchaUtils';

/**
 * Shows "open in Chrome/Safari" guidance.
 * - Always shown inside in-app browsers / WebViews (Instagram, WhatsApp, QR scanner apps...).
 * - Shown in normal browsers only after a reCAPTCHA failure (`force`).
 */
const BrowserCompatNotice = ({ force = false }) => {
    const env = getBrowserEnv();
    const [copied, setCopied] = useState(false);

    if (!env.isInApp && !force) return null;

    const chromeUrl = getOpenInChromeUrl();
    const href = typeof window !== 'undefined' ? window.location.href : '';

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(href);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch (_) {
            window.prompt('Bağlantıyı kopyalayın:', href);
        }
    };

    return (
        <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded-lg p-3 text-xs mb-3 leading-relaxed">
            <p className="font-semibold mb-1">
                {env.isInApp ? 'Uygulama içi tarayıcı tespit edildi' : 'Doğrulama sorunu mu yaşıyorsunuz?'}
            </p>
            <p className="mb-2">
                {env.isIOS
                    ? 'SMS doğrulaması en sorunsuz Safari\'de çalışır. Sağ üst/alt menüden "Safari\'de Aç" seçeneğini kullanın veya bağlantıyı kopyalayıp Safari\'ye yapıştırın.'
                    : 'SMS doğrulaması en sorunsuz Google Chrome\'da çalışır. Aşağıdaki butonla sayfayı Chrome\'da açabilirsiniz.'}
            </p>
            <div className="flex flex-wrap gap-2">
                {chromeUrl && (
                    <a
                        id="open-in-chrome-btn"
                        href={chromeUrl}
                        className="inline-block bg-amber-600 text-white px-3 py-1.5 rounded-md font-medium hover:bg-amber-700"
                    >
                        Chrome'da Aç
                    </a>
                )}
                <button
                    id="copy-page-link-btn"
                    type="button"
                    onClick={copyLink}
                    className="bg-white border border-amber-300 px-3 py-1.5 rounded-md font-medium hover:bg-amber-100"
                >
                    {copied ? 'Kopyalandı ✓' : 'Bağlantıyı Kopyala'}
                </button>
            </div>
        </div>
    );
};

export default BrowserCompatNotice;
